import React from "react";
import { Form, InputNumber } from "antd";

const AdnInputNumber = ({
    name,
    label,
    prefix,
    placeholder,
    rules,
    value,
    addonBefore,
    addonAfter,
    readOnly,
    handleChange,
    handleBlur,
    validateTrigger = 'onBlur',
    min,
    max
}) => {
    return (
        <div>
            <Form.Item
                name={name}
                valuePropName={value}
                label={label}
                rules={readOnly ? [] : rules} validateTrigger={validateTrigger}
            >
                <InputNumber
                    style={{ width: "100%" }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    prefix={prefix}
                    placeholder={readOnly ? "" : placeholder}
                    addonBefore={addonBefore}
                    addonAfter={addonAfter}
                    readOnly={readOnly || false}
                    min={min}
                    max={max}
                />
            </Form.Item>
        </div>
    );
};

export default AdnInputNumber;